import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import HeaderWithTag from "../../common/header_with_tag";
import { IUpdateBeneficiaryDetailsRequest } from "../../types/types";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";
import TryUpdateBeneficiaryDetails from "./try";

const requestCode: IUpdateBeneficiaryDetailsRequest = {
  ttno: "TT123456",
  beneficiaryName: "Updated Name",
  beneficiaryMobile: "1234567890"
};

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": {
    "ttno": "TT123456",
    "beneficiaryName": "Updated Name",
    "beneficiaryMobile": "1234567890"
  }
}`;

const failureResponseCode = `{
  "statusCode": 400,
  "message": "Failed to update beneficiary details",
  "errorCode": "DPI-4005",
  "data": null
}`;

function UpdateBeneficiaryDetails() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Update Beneficiary Details</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Update Beneficiary Details
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Update beneficiary details"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          POST
                        </span>
                        {HOST_API_URL}/Remittances/UpdateBeneficiaryDetails
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Updates the beneficiary information for an existing transaction. Provide the transaction number (TTNO) and the new beneficiary details.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Request"
                          headerTag="request"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameter</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Required</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>ttno</td>
                                <td>string</td>
                                <td>Transaction number</td>
                                <td>Yes</td>
                                <td>6</td>
                                <td>20</td>
                              </tr>
                              <tr>
                                <td>beneficiaryName</td>
                                <td>string</td>
                                <td>Beneficiary name</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>100</td>
                              </tr>
                              <tr>
                                <td>beneficiaryMobile</td>
                                <td>string</td>
                                <td>Beneficiary mobile number</td>
                                <td>Yes</td>
                                <td>7</td>
                                <td>15</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={JSON.stringify(requestCode, null, 2)}
                          codeBlackText="Request"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>statusCode</td>
                                <td>integer</td>
                                <td>200 on success, otherwise the failure status</td>
                              </tr>
                              <tr>
                                <td>message</td>
                                <td>string</td>
                                <td>"Success", or the reason for the failure</td>
                              </tr>
                              <tr>
                                <td>errorCode</td>
                                <td>string</td>
                                <td>null on success; a stable DPI-xxxx code on failure</td>
                              </tr>
                              <tr>
                                <td>data</td>
                                <td>object</td>
                                <td>
                                  Echoes the updated beneficiary details on success; null
                                  on failure
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={failureResponseCode}
                          codeBlackText="Failure Example"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                    Code Samples
                  </h5>

                  <TryUpdateBeneficiaryDetails
                    codeBlackTitle="Request Example"
                    updateBeneficiaryDetailsObject={requestCode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateBeneficiaryDetails;